module.exports = __webpack_public_path__ + "img/phone-ft.359ba076.png";